import { LOCALES, useT, type Locale } from '@/lib/i18n';
import { useLocaleStore } from '@/stores/locale.store';
import { cn } from '@/lib/utils';

const SHORT: Record<Locale, string> = { id: 'ID', en: 'EN' };

/**
 * #1853 — the ID / EN switch. `tone="rail"` sits on the dark left rail;
 * `tone="light"` on the cream login / device-setup screens.
 */
export function LanguageSwitch({ tone = 'light', className }: { tone?: 'rail' | 'light'; className?: string }) {
  const { locale, t } = useT();
  const setLocale = useLocaleStore((s) => s.setLocale);
  return (
    <div
      role="group"
      aria-label={t('lang.label')}
      className={cn(
        'inline-flex rounded-lg p-0.5',
        tone === 'rail' ? 'bg-white/10' : 'border border-border bg-card',
        className,
      )}
    >
      {LOCALES.map((l) => {
        const active = l === locale;
        return (
          <button
            key={l}
            type="button"
            aria-pressed={active}
            data-testid={`lang-${l}`}
            onClick={() => setLocale(l)}
            className={cn(
              'rounded-md px-2 py-0.5 text-[10px] font-bold tracking-wide transition-colors',
              tone === 'rail'
                ? active
                  ? 'bg-gold-500 text-ink-900'
                  : 'text-cream-100 hover:bg-white/10'
                : active
                  ? 'bg-primary text-primary-foreground'
                  : 'text-ink-500 hover:bg-secondary',
            )}
          >
            {SHORT[l]}
          </button>
        );
      })}
    </div>
  );
}
